module.exports = __webpack_public_path__ + "empty-state-avatar.svg?0bbdaf1f943f1aa38422f498f99c8908";